export const Imprint = {
    version: '2.2.0'
};
//# sourceMappingURL=imprint.js.map